e4.product = {
    init: function () {
        if ( jQuery( '.js-e-product-form, .js-e-productlist' ).length > 0 ) {
            e4.util.require.js( e4.settings.require.jQueryValidate, function () {
            } );
        }
        if ( jQuery( '.js-e-product' ).length > 0 ) {
            e4.util.require.js( e4.settings.require.handlebars, function () {
                e4.handlebars.registerHelpers( 'compare' );
                e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-il-product-detail-delivery-price-container' );
                e4.product.bindEvents();
            } );
        }
    },
    bindEvents: function () {
        jQuery( '.js-e-product-form' ).each( function ( intIndex, domForm ) {
            e4.product.validateForm( domForm );
        } );
        jQuery( '.js-e-productlist' ).on( 'builded.e4.productlist', function ( event ) {
            jQuery( event.target ).find( '.js-e-product-form' ).each( function ( intIndex, domForm ) {
                e4.product.validateForm( domForm );
            } );
        } );
    },
    validateForm: function ( domForm ) {
        var jForm = jQuery( domForm );
        jForm.validate( {
            submitHandler: function ( domForm ) {
                if ( jForm.is( '.js-e-product-form-removefromcart' ) === true ) {
                    e4.product.removeFromCart( domForm );
                }
                else /* if ( jForm.is( '.js-e-product-form-addtocart' ) === true )*/ {
                    e4.product.addToCart( domForm );
                }
            }
        } );
    },
    modifyProductNumber: function ( strProductNumber, strTextileId ) {
        var returnValue = strProductNumber;
        returnValue     = returnValue.split( 'XXX' ).join( strTextileId );
        return returnValue;
    },
    getProduct: function ( strProductNumber, strFabric ) {
        strProductNumber = ''+strProductNumber;
        if(strProductNumber.indexOf('XXX') === -1 && strProductNumber.indexOf('ZZZ') === -1){
            strFabric = '';
        }
        jQuery.ajax( {
            method: 'GET',
            dataType: 'json',
            url: e4.settings.ecom.product.url,
            cache: false,
            data: {
                ProductNumber: strProductNumber,
                TextileId: strFabric
            },
            beforeSend: function () {
                jQuery( '.js-e-products-loading-overlay' ).addClass( 'is-loading' );
            }
        } ).done( function ( data ) {
            if ( data.products.length === 1 ) {
                data.products[ 0 ].textileID = strFabric;
                e4.product.updateProductDetail( data.products[ 0 ] );
            }
            else {
                e4.product.disableBuy();
            }
        } ).fail( function ( jqXHR, textStatus, errorThrown ) {
            console.log( 'fail', jqXHR, textStatus, errorThrown );
        } ).always( function () {
            console.log( 'always' );
        } );
    },
    disableBuy: function () {
        var jElementDetail = jQuery( '.js-e-product' );
        jElementDetail.find( '.js-il-price-buy-container' ).addClass( 'd-none' );
        jElementDetail.find( '.js-il-no-buy-container' ).removeClass( 'd-none' );
    },
    updateProductDetail: function ( productData ) {
        console.log( 'updateProductDetail', productData );
        var jElementDetail = jQuery( '.js-e-product' );
        var jCartForm      = jElementDetail.find( '.js-e-product-form' );
        jCartForm.find( 'input[name="EcomOrderLineFieldInput_TextileID"]' ).val( productData.textileID );
        jCartForm.find( 'input[name="EcomOrderLineFieldInput_DeliveryWeek"]' ).val( productData.deliveryWeek );
        jCartForm.find( 'input[name="Number"]' ).val( productData.number );
        jCartForm.find( 'input[name="Price"]' ).val( productData.resellerPrice );
        console.log( '___productData', productData );
        jQuery( '.js-il-product-detail-delivery-price-container' ).html( e4.handlebars.tmpl.ilProductDetailDeliveryPriceContainer( productData ) );
        //jElementDetail.find('.js-il-price-formatted').html(productData.resellerPriceFormatted);
        jElementDetail.find( '.js-il-no-buy-container' ).addClass( 'd-none' );
        jElementDetail.find( '.js-il-price-buy-container' ).removeClass( 'd-none' );
    },
    addToCart: function ( domForm ) {
        console.log( '___addToCart' );
        var jForm       = jQuery( domForm ),
            arrFormData = jForm.serializeArray(),
            objFormData = {};
        for ( var i = 0; i < arrFormData.length; i++ ) {
            objFormData[ arrFormData[ i ].name ] = arrFormData[ i ].value;
        }
        jQuery.extend( objFormData, {
            Redirect: false
        } );
        console.log( '___is DM', jForm.is( '.js-e-product-form-download' ) );
        if ( jForm.is( '.js-e-product-form-download' ) === true ) {
            e4.download.cart.addProduct( objFormData );
        }
        else {
            console.log('objFormData', objFormData);
            e4.cart.addProduct( objFormData );
        }
    },
    removeFromCart: function ( domForm ) {
        var jForm       = jQuery( domForm ),
            arrFormData = jForm.serializeArray(),
            objFormData = {};
        for ( var i = 0; i < arrFormData.length; i++ ) {
            objFormData[ arrFormData[ i ].name ] = arrFormData[ i ].value;
        }
        jQuery.extend( objFormData, {
            Redirect: false
        } );
        if ( jForm.is( '.js-e-product-form-download' ) === true ) {
            e4.download.cart.removeProduct( objFormData );
        }
        else {
            e4.cart.removeProduct( objFormData );
        }
    }
};
